import { useState, useEffect, useContext } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'

import useAuth from './components/hooks/useAuth'
import useUrlQueryParams from './components/hooks/useUrlQueryParams'
import { Panel } from './components/Panel'
import { Input } from './components/inputs/Form'
import Button from './rentalManagerViews/rentalManagerComponents/button'

import backgroundImage from '../../public/images/beach_640.jpg'

export default function ResetPass() {
  const query = useUrlQueryParams()
  const history = useHistory()
  const token = query.get('token')
  const { resetPass } = useAuth()

  const [apiErrors, setApiErrors] = useState({})

  const formik = useFormik({
    initialValues: {
      NewPassword: '',
      ConfirmPassword: '',
    },
    validationSchema: Yup.object({
      NewPassword: Yup.string()
        .min(8, 'Must be at least 8 characters')
        .required('Required'),
      ConfirmPassword: Yup.string().oneOf(
        [Yup.ref('NewPassword'), null],
        'Passwords must match'
      ),
    }),
    onSubmit: ({ ConfirmPassword }) => {
      resetPass(ConfirmPassword, token)
        .then(res => {
          history.replace('/')
        })
        .catch(err => {
          const errors = {}
          err.errors?.forEach(err => {
            errors[err.param] = err.msg
          })
          setApiErrors(errors)
          console.dir(err)
        })
    },
  })

  return (
    <div>
      <Background />
      <Grid>
        <StyledPanel>
          <Header>
            <Title>Skillion Ride System</Title>
          </Header>

          <StyledForm onSubmit={formik.handleSubmit}>
            <InputFullWidth
              type="password"
              id="NewPassword"
              label="New Password"
              inputProps={{ className: 'browser-default' }}
              value={formik.values.NewPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                (formik.errors.NewPassword && formik.touched.NewPassword) ||
                  apiErrors?.NewPassword
                  ? apiErrors?.NewPassword || formik.errors.NewPassword
                  : null
              }
            ></InputFullWidth>
            <InputFullWidth
              type="password"
              id="ConfirmPassword"
              label="Confirm Password"
              inputProps={{ className: 'browser-default' }}
              value={formik.values.ConfirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                (formik.errors.ConfirmPassword &&
                  formik.touched.ConfirmPassword) ||
                  apiErrors?.ConfirmPassword
                  ? apiErrors?.ConfirmPassword || formik.errors.ConfirmPassword
                  : null
              }
            ></InputFullWidth>

            <FormFooter>
              <StyledButton type="submit">RESET</StyledButton>
            </FormFooter>
          </StyledForm>
        </StyledPanel>
      </Grid>
    </div>
  )
}

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
const Title = styled.h4`
  text-align: center;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
`

const StyledPanel = styled(Panel)`
  margin: 10vh 0;
  grid-column: span 6;
  @media ${props => props.theme.device.mobileL} {
    grid-column: 2 / span 4;
  }
  @media ${props => props.theme.device.tablet} {
    padding: 2em;
  }
  @media ${props => props.theme.device.laptopL} {
    grid-column: 3 / span 2;
  }
`
const StyledForm = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 2em 0em;
`

const FormFooter = styled.div`
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 3em;
`
const StyledButton = styled(Button)`
  width: clamp(1rem, 50%, 25rem);
`

const InputFullWidth = styled(Input)`
  grid-column: span 2;
`

const Background = styled.div`
  background-image: url(${backgroundImage});
  background-size: cover;
  filter: blur(5px);
  position: fixed;
  display: block;
  z-index: -1;
  left: -5px;
  right: -5px;
  top: -5px;
  bottom: -5px;
`
